<template lang="pug">
apollo-query(:query="query" @result="onResult")
  template(slot-scope="{ result: { loading, error, data } }")
    .loading(v-if="loading") Loading...

    .error(v-else-if="error") An error occured

    .no-result(v-else-if="!data") No result

    slot(:data="coaches") Implement required
</template>

<script>
import { FETCH_AVEX_COACHES_QUERY } from '@/graphql'
import createCoach from '@/entities/Coach'

export default {
  data() {
    return {
      query: FETCH_AVEX_COACHES_QUERY,
      coaches: [],
    }
  },
  methods: {
    onResult(result) {
      const coachNodes = result?.data?.avexCoaches?.nodes || []
      this.coaches = coachNodes.map((n) => createCoach(n))
      this.$emit('result', this.coaches)
    },
  },
}
</script>
